// extracted by mini-css-extract-plugin
var _1 = "DocFlowSelectModal-moduleemptyState__wIpLL";
var _2 = "DocFlowSelectModal-moduletable__rto7_ TableComponent-moduleTable__mhqNq";
export { _1 as "emptyState", _2 as "table" }
